import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["Escalations"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      startUpworkEscalation: build.mutation<
        StartUpworkEscalationApiResponse,
        StartUpworkEscalationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/upwork-escalations/start/`,
          method: "POST",
          body: queryArg.startUpworkEscalationRequest,
        }),
        invalidatesTags: ["Escalations"],
      }),
      getUpworkEscalationStatus: build.query<
        GetUpworkEscalationStatusApiResponse,
        GetUpworkEscalationStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/upwork-escalations/status/`,
        }),
        providesTags: ["Escalations"],
      }),
      cancelUpworkEscalation: build.mutation<
        CancelUpworkEscalationApiResponse,
        CancelUpworkEscalationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/upwork-escalations/cancel/`,
          method: "POST",
          body: queryArg.cancelUpworkEscalationRequest,
        }),
        invalidatesTags: ["Escalations"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type StartUpworkEscalationApiResponse =
  /** status 201  */ StartUpworkEscalationResponse;
export type StartUpworkEscalationApiArg = {
  matterId: string;
  taskId: string;
  startUpworkEscalationRequest: StartUpworkEscalationRequest;
};
export type GetUpworkEscalationStatusApiResponse =
  /** status 200  */ UpworkEscalationStatusResponse;
export type GetUpworkEscalationStatusApiArg = {
  matterId: string;
  taskId: string;
};
export type StartUpworkEscalationResponse = {
  workflow_id: string;
  matter_id: string | string;
  task_id: string | string;
  message: string;
};
export type UpworkEscalationPolicyKey = "medical_records_v1";
export type StartUpworkEscalationRequest = {
  policy_key: UpworkEscalationPolicyKey;
  phone_number_override?: string | null;
  sla_minutes?: number;
};
export type CancelUpworkEscalationApiResponse =
  /** status 200  */ CancelUpworkEscalationResponse;
export type CancelUpworkEscalationApiArg = {
  matterId: string;
  taskId: string;
  cancelUpworkEscalationRequest: CancelUpworkEscalationRequest;
};
export type CancelUpworkEscalationRequest = {
  reason?: string | null;
};
export type CancelUpworkEscalationResponse = {
  ok: boolean;
  message: string;
};
export type UpworkEscalationStatusResponse = {
  workflow_id: string;
  has_active_upwork_escalation: boolean;
  active_upwork_escalation_started_at?: string | null;
  last_upwork_escalation_started_at?: string | null;
};
export const {
  useStartUpworkEscalationMutation,
  useGetUpworkEscalationStatusQuery,
  useCancelUpworkEscalationMutation,
} = injectedRtkApi;
